import { Link } from "react-router-dom";

export const HlDebug = () => {
  return (
    <ul>
      <li>
        <Link to="facets">Facets</Link> - Info about current user facets
      </li>
      <li>
        <Link to="awards">Awards</Link> - Info about current user awards
      </li>
      <li>
        <Link to="next-steps">Next Steps</Link> - Debug next steps
        recommendation engine
      </li>
      <li>
        <Link to="palette">Palette</Link> - Overall app color palette
      </li>
      <li>
        <Link to="flags">Flags</Link> - Debugging feature flags (and product
        plan)
      </li>
      <li>
        <Link to="reset-user">Reset User</Link> - DANGER: Reset current user
        data
      </li>
      <li>
        <Link to="ms-hats-country">Hats Debug</Link> - List 10-at-a-time hats by
        region type
      </li>
      <li>
        <Link to="pdf-preview">PDF Preview</Link> - Preview Career Plan PDF
        without downloading
      </li>
    </ul>
  );
};
